import { useCallback, useState } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

const SwitchAppBar = () => {

  const [checked, setChecked] = useState(false);

  const sleep = (ms : number) => new Promise(r => setTimeout(r, ms));

  const onChangeSwitch = useCallback(async () => {
    setChecked((r) => !r);
    await sleep(500)
    window.open('https://www.ridecore.com/es');
    await sleep(1500)
    setChecked(false);
  }, [sleep, setChecked])

  return (
    <FormControlLabel
      control={
        <Switch
          sx={{ transform: 'rotate(90deg)', marginRight: '-14px' }}
          checked={checked}
          onChange={() => onChangeSwitch()}
        />
      }
      label={
        <Box display="flex" alignItems="flex-start" flexDirection={"column"} sx={{ gap: '0px' }}>
          <Typography
          variant="button"
          sx={{
            color: checked ? "#C3C3C3" : "#ffffff",
            fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
            fontWeight: "bold",
            marginBottom: "-4px",
            fontSize: '15px'
          }}
        >
          LATAM
        </Typography>
          <Typography
            variant="button"
            sx={{ color: checked ? "#ffffff" : "#C3C3C3", 
            fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
            fontWeight: "bold",
            marginTop: '-4px',
            fontSize: '15px'
          }}>
            GLOBAL
          </Typography>
        </Box>
      }
    />
  );
};

export default SwitchAppBar;
